<section class="ayuda">
	<iframe src="assets/documents/PREGUNTAS-FRECUENTES-PAWERFUL.pdf" frameborder="0"></iframe>	
</section>
<style>
	.ayuda{
		width: 80%;
		margin: 40px auto;
	}
	.ayuda > iframe{
		width: 100%;
		height: 80vh;
	}
</style>